<template>
  <div class="exam-poster-base-comp">
    <div class="header">
      <img src="../assets/img_exam_title@2x.png" />
    </div>
    <div class="main">
      <div class="content-box">
        <div class="info">
          <div class="tip">
            本校研究决定开展线上《体育与健康》考试。根据线上考试特点，结合学校考试工作实际，现将线上考试有关要求通知如下：
          </div>

          <div class="item">
            <div class="title">考试时间</div>
            <div class="date">
              {{ formatDate(examStatisticInfo.exam.start_datetime) }} ~
              {{ formatDate(examStatisticInfo.exam.end_datetime) }}
            </div>
          </div>

          <div class="item">
            <div class="title">考试方式</div>
            <div class="detail">线上考试</div>
            <div class="tip">*具体考试细则详见天天跳绳app，需要升级最新版本</div>
          </div>

          <div class="item">
            <div class="title">考试班级</div>
            <div class="detail">
              <div class="grade-info" v-for="(grade, index) in gradeInfo" :key="index">
                <div class="grade-name">
                  {{ buildGradeName(index) }}
                </div>
                <div class="clazz-list">
                  <div class="name" v-for="(clazz, clazzIndex) in grade" :key="clazzIndex">
                    {{ clazz.note_name || clazz.name }}
                    <span v-if="clazzIndex !== grade.length - 1">、</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="school"><span></span> {{ schoolName }}</div>
        </div>
      </div>
    </div>

    <poster-footer class="footer" is-ttts scene="knowledge-exam" />
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop, PosterFooter } from 'kuaidong-component'
import { IPaperExamStaticInfo } from 'kuaidong-model'
import { DateWrapper, SchoolUtil } from 'kuaidong-lib'
import groupBy from 'lodash/groupBy'

@Component({
  components: {
    PosterFooter,
  },
})
export default class ExamPosterBaseComp extends BaseComponent {
  @Prop({ type: Object, required: true })
  examStatisticInfo!: IPaperExamStaticInfo

  get schoolName() {
    if (this.examStatisticInfo && this.examStatisticInfo.exam.class_vo_list.length) {
      return this.examStatisticInfo.exam.class_vo_list[0].school?.school_name
    } else {
      return '--'
    }
  }

  get gradeInfo() {
    if (this.examStatisticInfo) {
      return groupBy(this.examStatisticInfo.exam.class_vo_list, 'grade_no')
    } else {
      return null
    }
  }

  formatDate(dt: string) {
    return `${new DateWrapper(dt).showDateStrShortCN}${new DateWrapper(dt).showTimeStr}`
  }

  buildGradeName(gradeNo: number) {
    return SchoolUtil.buildGradeName(gradeNo)
  }
}
</script>
<style lang="less">
.exam-poster-base-comp {
  width: 375px;
  box-sizing: border-box;
  > .poster-footer-ttts-comp {
    > .qrcode {
      width: 58px;
      height: 58px;
    }
  }

  > .header {
    background: #0995ff;
    > img {
      width: 100%;
    }
  }
  > .main {
    background: linear-gradient(#0d98ff, #f8fdff);
    > .content-box {
      border: 8px solid #1b93ff;
      border-radius: 8px;
      margin: 0 8px;
      > .info {
        background: #fff;
        border-radius: 8px;
        width: 100%;
        height: 100%;
        padding: 16px;
        box-sizing: border-box;
        > .tip {
          margin-top: 15px;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #1b64d1;
          text-align: left;
        }

        > .item {
          margin-top: 30px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          > .title {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #2d2f33;
            margin-bottom: 12px;

            background: rgba(154, 244, 255, 0.5);
            box-shadow: 3px 3px 0px #cee4ee;
            border-radius: 12px 12px 12px 2px;
            padding: 4px 12px;
          }
          > .date {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #4d4d4d;
          }
          > .detail {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #4d4d4d;
            text-align: left;
            > .grade-info {
              > .grade-name {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #4d4d4d;
              }
              > .clazz-list {
                display: flex;
                margin-top: 9px;
                flex-wrap: wrap;
                > .name {
                  font-weight: 400;
                  font-size: 12px;
                  line-height: 17px;
                  color: #8f8f8f;
                  white-space: nowrap;
                }
              }
            }
          }
          > .tip {
            margin-top: 12px;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: #8f8f8f;
          }
        }

        > .school {
          margin-top: 30px;
          text-align: right;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: #4d4d4d;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          > span {
            width: 46px;
            height: 2px;
            margin-right: 2px;
            background: #000;
            display: inline-block;
          }
        }
      }
    }
  }

  > .footer {
    padding: 16px;
    background: #fff;
  }
}
</style>
